module.exports = __webpack_public_path__ + "static/media/globe.a16f1b67.svg";